import React, { useState, useEffect } from 'react';
import axios from '@common/axios';
import { Alert } from 'antd';
import CircularLoader from '@common/CircularLoader';

const CustomActivity = ({ step, stepActivity }) => {
    const [isLoading, setLoading] = useState(true);
    const [customActivity, setCustomActivity] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        let isActive = true;

        if (!step || !stepActivity?.customActivityId) {
            setCustomActivity(undefined);
            setError(undefined);
            setLoading(false);
            return;
        }

        const loadCustomActivity = async (customActivityId) => {
            setLoading(true);
            setError(undefined);
            try {
                const response = await axios.get('/web/ui/trail/customActivity', {
                    params: { customActivityId },
                });

                if (isActive) {
                    setCustomActivity(response.data);
                }
            } catch (err) {
                if (isActive) {
                    console.error('Error loading custom activity:', err);
                    setError('Failed to load activity. Please try again.');
                }
            } finally {
                if (isActive) {
                    setLoading(false);
                }
            }
        };

        loadCustomActivity(stepActivity.customActivityId);

        return () => {
            isActive = false;
        };
    }, [step, stepActivity]);

    if (isLoading) {
        return (
            <div role="status" aria-busy="true" aria-live="polite">
                <CircularLoader />
            </div>
        );
    }

    if (error) {
        return <Alert showIcon={true} description={error} type="error" role="alert" />;
    }

    if (!customActivity) {
        return <Alert showIcon={true} description="Activity not found" type="error" role="alert" />;
    }

    return (
        <section className="ch-trail-custom-activity" aria-labelledby="custom-activity-title">
            <h3 id="custom-activity-title">{customActivity.title}</h3>

            {customActivity.message && <p>{customActivity.message}</p>}

            {customActivity?.linkUrl && (
                <div>
                    <h3>Quick Link</h3>
                    <p>
                        <a
                            className="ch-link"
                            href={customActivity?.linkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Quick link to ${customActivity?.linkUrl}`}
                        >
                            {customActivity?.linkUrl}
                        </a>
                    </p>
                </div>
            )}
        </section>
    );
};

export default CustomActivity;